<template>
    <modal name="puzzle" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'error-modal', 'puzzle']" :width="960" :height="'auto'" :adaptive="true">
        <div class="puzzle-header section-header">
            <span @click="$modal.hide('puzzle')" class="puzzle-back"></span>
            <div class="puzzle-owner user-item">
            </div>
            <div class="puzzle-links">
                <span @click="fromStart" class="link-light">
                    {{ $t("puzzles.startOver") }}
                </span>
                <span v-if="id" @click="remove" class="link-light">
                    {{ $t("threads.delete") }}
                </span>
            </div>
        </div>
        <div ref="wrapper" class="puzzle-body">
            <div ref="inner" id="inner" class="puzzle-inner">
                <div v-if="puzzleLoader" class="puzzle-loader"><span>
                        {{ $t("loading.loading") }}
                    </span></div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import * as PIXI from 'pixi.js';
import { randomInteger } from '@/mixins/randomInteger';
import { checkScroll } from '@/mixins/checkScroll';

export default {
    name: 'Puzzle',
    props: {
        i18n: Object,
    },
    mixins: [
        randomInteger,
        checkScroll
    ],
    data() {
        return {
            autoDetectRenderer: PIXI.autoDetectRenderer,
            loader: PIXI.Loader.shared,
            resources: PIXI.Loader.shared.resources,
            Container: PIXI.Container,
            Sprite: PIXI.Sprite,
            TextureCache: PIXI.utils.TextureCache,
            Rectangle: PIXI.Rectangle,
            app: null,
            animationFrame: false,
            xTileCount: 9,
            yTileCount: 9,
            piecesSelect: { x: 9, y: 9 },
            puzzleWidth: 600,
            puzzleHeight: 600,
            tileWidth: 0,
            tileRatio: 0,
            shapeArray: [],
            drData: null,
            dragging: false,
            startMouseX: 0,
            startMouseY: 0,
            startTileX: 0,
            startTileY: 0,
            deltaX: 0,
            deltaY: 0,
            targetX: 0,
            targetY: 0,
            magnet: 30,
            highlightMagnet: 30,
            completeCount: 0,
            totalCount: 0,
            hasProgress: false,
            id: '',
            // photoId: '',
            puzzleImg: '',
            puzzleJson: null,
            mobile: false,
            initialWidth: 921,
            initialHeight: 600,
            wrapper: null,
            inner: null,
            highlight: [],
            prevHover: null,
            clickedTile: null,
            resizeTimeout: null,
            puzzleLoader: true,
            removed: false
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/fetchUser',
            userIsEmpty: 'user/isEmpty',
            puzzles: 'puzzles/fetchPuzzles',
            puzzlesIsEmpty: 'puzzles/isEmpty',
            puzzle: 'puzzles/fetchPuzzle',
        }),
        // puzzle() {
        //     return this.$store.getters['puzzles/fetchPuzzleById'](parseInt(this.id));
        // }
    },
    watch: {
        '$route'(to, from) {
            if (to != from) {
                this.$modal.hide('puzzle');
            }
        }
    },
    methods: {
        beforeOpen(event) {
            // Защита от undefined params
            if (!event || !event.params) {
                console.error('Puzzle: event.params is undefined');
                return;
            }
            
            this.removed = false;
            this.puzzleLoader = true;
            this.id = null;
            this.puzzleJson = null;
            this.hasProgress = false;
            this.highlight = [];
            this.checkScroll();
            this.checkMobile();

            if (event.params.photoId) {
                this.getByPhotoId(event.params.photoId);
            } else if (event.params.id) {
                this.id = event.params.id;
                let cb = () => {
                    this.$store.dispatch(
                        'puzzles/getByPuzzleId', this.id
                    )
                        .then(() => {
                            this.setPuzzleData();
                        });
                }
                if (this.puzzlesIsEmpty('puzzles')) {
                    this.getPuzzles(cb);
                } else {
                    cb();
                }
            } else if (event.params.image) {
                this.setPuzzleData(event.params.image);
            }

            window.addEventListener('resize', this.checkRatio);
        },
        beforeClose() {
            this.checkRemoveScroll();
            if (this.hasProgress && !this.removed) {
                this.saveProgress(true);
            }

            window.removeEventListener('resize', this.checkRatio);

            this.animationFrame = false;
            this.app.destroy();
            delete this.app;
            let canvas = document.getElementById('canvasId');
            if (canvas) {
                canvas.parentNode.removeChild(canvas);
            }
        },
        saveProgress(removeId = false) {
            if (!this.id) return;
            this.$store.dispatch('puzzles/saveProgress', {
                id: this.id,
                data: {
                    progress: this.puzzleJson,
                    completed: this.calcProgress()
                }
            }).then(() => { if (removeId) this.id = '' });
        },
        calcProgress() {
            if (
                this.puzzleJson &&
                this.puzzleJson.completeCount
            ) {
                let pr = Math.floor(
                    this.puzzleJson.completeCount /
                    this.puzzleJson.totalCount * 100
                );
                return pr;
            }
            return 0;
        },
        checkMobile() {
            this.mobile = window.innerWidth > window.innerHeight ? false : true;
        },
        checkRatio(init = false) {
            let tempMobile = this.mobile;
            this.checkMobile();
            if (this.mobile == tempMobile) {
                this.scaleStage(init);
                return;
            }
            this.puzzleLoader = true;
            clearTimeout(this.resizeTimeout);

            this.animationFrame = false;

            this.resizeTimeout = setTimeout(() => {
                this.highlight = [];

                if (this.app) {
                    this.app.destroy();
                    delete this.app;
                    let canvas = document.getElementById('canvasId');
                    if (canvas) {
                        canvas.parentNode.removeChild(canvas);
                    }
                }
                this.scaleStage(true);

            }, 1000);
        },
        scaleStage(init = false) {
            this.initialWidth = this.mobile ? 600 : 921;
            this.initialHeight = this.mobile ? 921 : 600;
            this.inner.style.height = this.initialHeight;
            this.inner.style.width = this.initialWidth;

            let wrapperWidth = this.wrapper.clientWidth;
            let wrapperHeight = this.wrapper.clientHeight;
            let wrapperRatio = wrapperWidth / wrapperHeight;

            let scale, marginTop, marginLeft;
            if (
                (this.mobile && wrapperRatio <= 0.6514658) ||
                (!this.mobile && wrapperRatio <= 1.535)
            ) {
                scale = wrapperWidth / this.initialWidth;
                marginTop = (wrapperHeight - this.initialHeight * scale) / 2;
                marginLeft = 0;
            } else {
                scale = wrapperHeight / this.initialHeight;
                marginTop = 0;
                marginLeft = (wrapperWidth - this.initialWidth * scale) / 2;
            }

            this.inner.style.webkitTransform = 'scale(' + scale + ')';
            this.inner.style.mozTransform = 'scale(' + scale + ')';
            this.inner.style.msTransform = 'scale(' + scale + ')';
            this.inner.style.oTransform = 'scale(' + scale + ')';
            this.inner.style.transform = 'scale(' + scale + ')';
            this.inner.style.marginTop = marginTop + 'px';
            this.inner.style.marginLeft = marginLeft + 'px';

            if (init === true) {
                this.initPixi();
            }

        },
        getByPhotoId(id) {
            this.$store.dispatch('puzzles/getByPhotoId', id)
                .then(() => {
                    this.id = this.puzzle.id;
                    this.setPuzzleData();
                });
        },
        getPuzzles(cb) {
            this.$store.dispatch('puzzles/get')
                .then(() => {
                    cb();
                });
        },
        setPuzzleData(image = false) {
            this.puzzleImg = image || this.puzzle.image;
            if (this.puzzle && this.puzzle.progress) {
                this.puzzleJson = this.puzzle.progress
                this.piecesSelect = this.puzzle.progress.piecesCount;
                this.completeCount = this.puzzle.progress.completeCount || 0;
            } else {
                this.puzzleJson = { piecesCount: { x: 9, y: 9 } };
            }
            setTimeout(() => {
                this.wrapper = this.$refs.wrapper;
                this.inner = this.$refs.inner;
                // this.setOrientation();
                this.checkRatio(true);
            }, 500);
        },
        remove() {
            this.$modal.show('dialog', {
                title: this.$t("threads.warning"),
                text: this.$t("myPuzzles.puzzlesRemoved"),
                buttons: [
                    {
                        title: this.$t("threads.delete"),
                        handler: () => {
                            this.$store.dispatch('puzzles/remove', this.id)
                                .then(() => {
                                    this.removed = true;
                                    this.$modal.hide('dialog');
                                    this.$modal.hide('puzzle');
                                })
                                .catch((err) => {
                                    this.$modal.hide('dialog');
                                });
                        }
                    },
                    {
                        title: this.$t("stories.cancel"),
                    }
                ]
            })
        },
        setPiecesCount() {
            if (this.hasProgress) {
                this.$modal.show('dialog', {
                    title: this.$t("threads.warning"),
                    text: this.$t("myPuzzles.currentProgress"),
                    buttons: [
                        {
                            title: this.$t("myPuzzles.changeParts"),
                            handler: () => {
                                this.resetProgress();
                                this.$modal.hide('dialog');
                                return;
                            }
                        },
                        {
                            title: this.$t("stories.cancel"),
                            handler: () => {
                                this.piecesSelect = this.puzzleJson.piecesCount;
                                this.$modal.hide('dialog');
                                return;
                            }
                        }
                    ]
                });
            } else {
                this.resetProgress();
                return;
            }

        },
        fromStart() {
            this.$modal.show('dialog', {
                title: this.$t("threads.warning"),
                text: this.$t("myPuzzles.currentProgress"),
                buttons: [
                    {
                        title: this.$t("albumEdit.ok"),
                        handler: () => {
                            this.resetProgress();
                            this.$modal.hide('dialog');
                            return;
                        }
                    },
                    {
                        title: this.$t("stories.cancel"),
                        handler: () => {
                            this.$modal.hide('dialog');
                            return;
                        }
                    }
                ]
            })
        },
        resetProgress() {
            this.animationFrame = false;
            if (this.app) this.app.destroy();
            delete this.app;
            let canvas = document.getElementById('canvasId');
            if (canvas) {
                canvas.parentNode.removeChild(canvas);
            }

            this.puzzleJson.piecesCount = this.piecesSelect;
            this.puzzleJson.tiles = {};
            this.puzzleJson.completeCount = 0;
            this.puzzleJson.totalCount = 0;
            this.completeCount = 0;
            this.totalCount = 0;
            this.hasProgress = false;
            this.highlight = [];
            if (this.id) {
                this.$store.dispatch('puzzles/saveProgress', {
                    id: this.id,
                    data: null
                })
                    .then(() => {
                        this.initPixi();
                    });
            } else {
                this.initPixi();
            }
        },
        initPixi() {
            let self = this;

            if (!self.puzzleJson.tiles) {
                self.puzzleJson.tiles = {};
            }
            this.xTileCount = this.puzzleJson.piecesCount.x || 9;
            this.yTileCount = this.puzzleJson.piecesCount.y || 9;
            this.tileWidth = this.puzzleWidth / this.xTileCount;
            this.tileRatio = this.tileWidth / 100.0;
            this.totalCount = this.xTileCount * this.yTileCount;
            self.puzzleJson.totalCount = this.totalCount;

            let stageWidth = this.mobile ? 600 : 921;
            let stageHeight = this.mobile ? 921 : 600;

            let canvas = document.createElement('canvas');
            canvas.setAttribute("id", "canvasId");

            this.$refs.inner.appendChild(canvas)

            this.app = this.autoDetectRenderer({
                width: stageWidth,
                height: stageHeight,
                view: canvas,
                antialias: true
            });

            let stage = new self.Container();

            let tiles = self.puzzleJson.tiles;

            if (
                self.puzzleJson.tiles &&
                Object.keys(self.puzzleJson.tiles).length
            ) {
                self.hasProgress = true;
            };

            for (let textureUrl in PIXI.utils.BaseTextureCache) {
                delete PIXI.utils.BaseTextureCache[textureUrl];
            }
            for (let textureUrl in PIXI.utils.TextureCache) {
                delete PIXI.utils.TextureCache[textureUrl];
            }
            this.loader.reset();

            let url = require.context('@/assets/img', false, /\.svg$/);
            let angleImg = url('./round-angle.svg');

            this.loader
                .add('puzzle', this.puzzleImg)
                .add('angle', angleImg)
                .load(setup);

            function setup() {

                self.shapeArray = self.getRandomShapes(
                    self.xTileCount,
                    self.yTileCount
                );

                stage.sortableChildren = true;

                let texture = self.TextureCache['puzzle'];

                let background = new PIXI.Graphics();
                background.beginFill(0x282b2d);
                background.drawRoundedRect(0, 0, 600, 600, 10);

                background.interactive = true;
                background
                    .on('mouseup', _onMouseUp)
                    .on('mousemove', _onMouseMove)
                    .on('touchend', _onMouseUp);

                function _onMouseMove(event) {
                    if (self.clickedTile) {
                        let x = event.data.global.x,
                            y = event.data.global.y;

                        let hoverX, hoverY, hover;

                        hoverX = Math.floor(x / self.tileWidth);
                        hoverY = Math.floor(y / self.tileWidth);

                        hover = hoverX + hoverY * self.xTileCount;

                        if (typeof self.prevHover == 'number' && self.prevHover >= 0) {
                            self.highlight[self.prevHover].visible = false;
                        }

                        if (
                            hoverX <= self.xTileCount - 1 &&
                            hoverX >= 0 &&
                            hoverY <= self.yTileCount - 1 &&
                            hoverY >= 0
                        ) {
                            self.highlight[hover].visible = true;
                            self.prevHover = hover;
                        }
                    }

                }

                function _onMouseUp(event) {
                    if (self.clickedTile) {
                        let x = event.data.global.x,
                            y = event.data.global.y;

                        let tileX = self.clickedTile.name % self.xTileCount;
                        let tileY = Math.floor(self.clickedTile.name / self.yTileCount);

                        if (
                            Math.floor(x / self.tileWidth) == tileX &&
                            Math.floor(y / self.tileWidth) == tileY
                        ) {
                            self.clickedTile.position.x = self.targetX;
                            self.clickedTile.position.y = self.targetY;
                            self.clickedTile.removeChild(self.clickedTile.children[2]);
                            self.clickedTile.removeChild(self.clickedTile.children[1]);
                            self.clickedTile.zIndex = 0;
                            self.clickedTile.interactive = false;
                            self.clickedTile.buttonMode = false;
                            self.completeCount++;
                            self.puzzleJson.completeCount = self.completeCount;

                            tiles[self.clickedTile.name].mobileX =
                                tiles[self.clickedTile.name].desktopX =
                                self.targetX;

                            tiles[self.clickedTile.name].mobileY =
                                tiles[self.clickedTile.name].desktopY =
                                self.targetY;

                            self.saveProgress();

                            if (self.completeCount == self.totalCount) {
                                self.$modal.show('dialog', {
                                    title: this.$t("albumEdit.success"),
                                    text: this.$t("puzzles.putPuzzleTogether"),
                                    buttons: [
                                        {
                                            title: this.$t("albumEdit.ok")
                                        }
                                    ]
                                });
                            }

                        } else {
                            self.clickedTile.zIndex = 1;
                            self.clickedTile.children[2].visible = false;
                        }

                        self.clickedTile = null;
                        if (typeof self.prevHover == 'number' && self.prevHover >= 0) {
                            self.highlight[self.prevHover].visible = false;
                        }
                    }
                }

                let aside = new PIXI.Graphics();
                aside.lineStyle(2, 0x394045, 1, 0);
                if (self.mobile) {
                    aside.drawRoundedRect(0, 609, 600, 312, 10);
                } else {
                    aside.drawRoundedRect(609, 0, 312, 600, 10);
                }

                let angleTexture = self.TextureCache['angle'];
                let roundAngle1 = new self.Sprite(angleTexture);
                let roundAngle2 = new self.Sprite(angleTexture);
                let roundAngle3 = new self.Sprite(angleTexture);
                let roundAngle4 = new self.Sprite(angleTexture);

                roundAngle1.x = 5;
                roundAngle1.y = 5;
                roundAngle1.anchor.set(0.5);
                roundAngle1.rotation = Math.PI;
                roundAngle1.interactive = true;
                roundAngle1.zIndex = 2;

                roundAngle2.x = 595;
                roundAngle2.y = 5;
                roundAngle2.anchor.set(0.5);
                roundAngle2.rotation = Math.PI * 1.5;
                roundAngle2.interactive = true;
                roundAngle2.zIndex = 2;

                roundAngle3.x = 595;
                roundAngle3.y = 595;
                roundAngle3.anchor.set(0.5);
                roundAngle3.rotation = Math.PI * 2
                roundAngle3.interactive = true;
                roundAngle3.zIndex = 2;

                roundAngle4.x = 5;
                roundAngle4.y = 595;
                roundAngle4.anchor.set(0.5);
                roundAngle4.rotation = Math.PI * 0.5;;
                roundAngle4.interactive = true;
                roundAngle4.zIndex = 2;

                stage.addChild(background);
                stage.addChild(aside);
                stage.addChild(roundAngle1);
                stage.addChild(roundAngle2);
                stage.addChild(roundAngle3);
                stage.addChild(roundAngle4);

                for (let y = 0; y < self.yTileCount; y++) {
                    for (let x = 0; x < self.xTileCount; x++) {

                        let index = y * self.xTileCount + x;
                        let shape;

                        if (self.hasProgress) {
                            shape = tiles[index].shape;
                        } else {
                            tiles[index] = {};
                            tiles[index].shape = shape = self.shapeArray[index];
                        }

                        let startPoint = {
                            x: x * self.tileWidth,
                            y: y * self.tileWidth
                        };
                        let maskArr = self.getMask(
                            texture,
                            startPoint,
                            shape.topTab,
                            shape.rightTab,
                            shape.bottomTab,
                            shape.leftTab
                        );
                        let mask = maskArr.mask;
                        let mask1 = maskArr.mask;
                        let bgLine = maskArr.bgLine;
                        let bgHighlight = maskArr.bgHighlight;
                        let borderGrey = maskArr.borderGrey;
                        let borderAccent = maskArr.borderAccent;
                        borderAccent.visible = false;

                        let tile = new self.Sprite();
                        let tile1 = new self.Sprite(texture);
                        let tile2 = new self.Sprite(texture);

                        tile.name = index;

                        tile1.mask = mask;

                        tile1.addChild(mask);

                        tile.addChild(tile1);
                        background.addChild(bgLine);
                        bgHighlight.name = 'hl' + index;
                        self.highlight.push(bgHighlight);
                        background.addChild(bgHighlight);
                        bgHighlight.visible = false;

                        let ready = false;
                        let posProperty = self.mobile ? 'mobile' : 'desktop';

                        if (self.hasProgress) {
                            tile.x = tiles[index][posProperty + 'X'];
                            tile.y = tiles[index][posProperty + 'Y'];

                            if (
                                tiles[index][posProperty + 'X'] ==
                                self.targetX &&
                                tiles[index][posProperty + 'Y'] ==
                                self.targetY
                            ) {
                                ready = true;
                            }

                        } else {

                            let deltaX = x * self.tileWidth;
                            let deltaY = y * self.tileWidth;

                            let newMobileX = self.randomInteger(
                                21 - deltaX,
                                578 - self.tileWidth - deltaX
                            )
                            let newMobileY = self.randomInteger(
                                632 - deltaY,
                                899 - self.tileWidth - deltaY
                            )

                            let newDesktopX = self.randomInteger(
                                632 - deltaX,
                                899 - self.tileWidth - deltaX
                            )
                            let newDesktopY = self.randomInteger(
                                21 - deltaY,
                                578 - self.tileWidth - deltaY
                            )

                            tiles[index].mobileX = newMobileX;
                            tiles[index].mobileY = newMobileY;
                            tiles[index].desktopX = newDesktopX;
                            tiles[index].desktopY = newDesktopY;

                            tile.x = self.mobile ? newMobileX : newDesktopX;
                            tile.y = self.mobile ? newMobileY : newDesktopY;
                        }

                        if (!ready) {
                            tile.addChild(borderGrey);
                            tile.addChild(borderAccent);
                            tile.interactive = true;
                            tile.buttonMode = true;
                            tile.zIndex = 1;

                            tile
                                .on('mousedown', onDragStart)
                                .on('touchstart', onDragStart)
                                .on('mouseup', onDragEnd)
                                .on('mouseupoutside', onDragEnd)
                                .on('touchend', onDragEnd)
                                .on('touchendoutside', onDragEnd)
                                .on('mousemove', onDragMove)
                                .on('touchmove', onDragMove);
                        }

                        stage.addChild(tile);
                    }
                }


                self.animationFrame = true;
                requestAnimationFrame(animate);

                function animate() {
                    if (!self.animationFrame) return;
                    setTimeout(() => {
                        requestAnimationFrame(animate);
                    }, 40);
                    self.app.render(stage);
                }

                function bgMouseOver(event) {
                    this.visible = true;
                }

                function bgMouseMove(event) {
                    this.alpha = 1;
                }

                function onDragStart(event) {
                    this.data = event.data;
                    self.startMouseX = event.data.global.x;
                    self.startMouseY = event.data.global.y;
                    self.startTileX = this.position.x;
                    self.startTileY = this.position.y;
                    this.dragging = true;
                }

                function onDragEnd() {
                    if (!this.data) return;
                    let newPosition = this.data.getLocalPosition(this.parent);
                    if (
                        Math.abs(newPosition.x - self.startMouseX) <= 20 &&
                        Math.abs(newPosition.y - self.startMouseY) <= 20
                    ) {
                        if (self.clickedTile == null || self.clickedTile != this) {
                            if (self.clickedTile != null) {
                                self.clickedTile.zIndex = 1;
                                self.clickedTile.children[2].visible = false;
                            }
                            self.clickedTile = this;
                            this.zIndex = 3;
                            this.children[2].visible = true;
                        } else {
                            self.clickedTile = null;
                            this.zIndex = 1;
                            this.children[2].visible = false;
                        }
                        this.position.x = self.startTileX;
                        this.position.y = self.startTileY;
                        if (typeof self.prevHover == 'number' && self.prevHover >= 0) {
                            self.highlight[self.prevHover].visible = false;
                        }
                        this.dragging = false;
                        this.data = null;
                        return;
                    }

                    self.clickedTile = null;
                    this.children[2].visible = false;
                    this.zIndex = 1;
                    this.dragging = false;
                    this.data = null;

                    if (typeof self.prevHover == 'number' && self.prevHover >= 0) {
                        self.highlight[self.prevHover].visible = false;
                    }

                    if (
                        (
                            self.mobile &&
                            tiles[this.name].mobileX == this.position.x &&
                            tiles[this.name].mobileY == this.position.y
                        ) ||
                        (
                            !self.mobile &&
                            tiles[this.name].desktopX == this.position.x &&
                            tiles[this.name].desktopY == this.position.y
                        )
                    ) {
                        return;
                    } else if (
                        this.position.x < self.targetX + self.tileWidth / 2 &&
                        this.position.x > self.targetX - self.tileWidth / 2 &&
                        this.position.y < self.targetY + self.tileWidth / 2 &&
                        this.position.y > self.targetY - self.tileWidth / 2
                    ) {
                        this.position.x = self.targetX;
                        this.position.y = self.targetY;
                        this.removeChild(this.children[1]);
                        this.zIndex = 0;
                        this.interactive = false;
                        this.buttonMode = false;
                        self.completeCount++;
                        self.puzzleJson.completeCount = self.completeCount;

                        tiles[this.name].mobileX =
                            tiles[this.name].desktopX =
                            self.targetX;

                        tiles[this.name].mobileY =
                            tiles[this.name].desktopY =
                            self.targetY;

                        self.saveProgress();

                        if (self.completeCount == self.totalCount) {
                            self.$modal.show('dialog', {
                                title: this.$t("albumEdit.success"),

                                text: this.$t("puzzles.putPuzzleTogether"),
                                buttons: [
                                    {
                                        title: this.$t("albumEdit.ok")
                                    }
                                ]
                            });
                        }
                    } else if (
                        tileInTable(this.name, this.position.x, this.position.y)
                    ) {
                        if (self.mobile) {
                            tiles[this.name].mobileX = this.position.x;
                            tiles[this.name].mobileY = this.position.y;
                        } else {
                            tiles[this.name].desktopX = this.position.x;
                            tiles[this.name].desktopY = this.position.y;
                        }

                        self.saveProgress();

                    } else {
                        this.position.x =
                            self.mobile ?
                                tiles[this.name].mobileX :
                                tiles[this.name].desktopX;

                        this.position.y =
                            self.mobile ?
                                tiles[this.name].mobileY :
                                tiles[this.name].desktopY;
                    }

                    self.hasProgress = true;
                }

                function tileInTable(index, x, y) {
                    // return false;
                    let minX, maxX, minY, maxY;

                    let indexX =
                        ((index + 1) % self.xTileCount) == 0 ?
                            self.xTileCount - 1 :
                            ((index + 1) % self.xTileCount) - 1;

                    let indexY = Math.floor(index / self.xTileCount);

                    let deltaX = indexX * self.tileWidth;
                    let deltaY = indexY * self.tileWidth;

                    if (self.mobile) {
                        minX = 10 - deltaX;
                        maxX = 590 - self.tileWidth - deltaX;
                        minY = 620 - deltaY;
                        maxY = 910 - self.tileWidth - deltaY;
                    } else {
                        minX = 620 - deltaX;
                        maxX = 910 - self.tileWidth - deltaX;
                        minY = 10 - deltaY;
                        maxY = 590 - self.tileWidth - deltaY;
                    }

                    if (
                        parseFloat(x) >= parseFloat(minX) &&
                        parseFloat(x) <= parseFloat(maxX) &&
                        parseFloat(y) >= parseFloat(minY) &&
                        parseFloat(y) <= parseFloat(maxY)
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                }

                function onDragMove() {
                    if (this.dragging) {
                        this.zIndex = 3;

                        let newPosition = this.data.getLocalPosition(this.parent);
                        let maxX = self.mobile ? 600 : 900;
                        let maxY = self.mobile ? 900 : 600;
                        let shift = self.mobile ? 120 : 0;
                        this.position.x =
                            newPosition.x < maxX &&
                                newPosition.x > 0 ?
                                self.startTileX +
                                newPosition.x -
                                self.startMouseX :
                                this.position.x;
                        this.position.y =
                            newPosition.y < maxY &&
                                newPosition.y > 0 ?
                                self.startTileY +
                                newPosition.y -
                                self.startMouseY - shift :
                                this.position.y;

                        let hoverX, hoverY, hover;

                        let tileX = this.name % self.xTileCount;
                        let tileY = Math.floor(this.name / self.yTileCount);

                        hoverX = Math.floor((this.position.x + self.tileWidth / 2 + tileX * self.tileWidth) / self.tileWidth);
                        hoverY = Math.floor((this.position.y + self.tileWidth / 2 + tileY * self.tileWidth) / self.tileWidth);

                        hover = hoverX + hoverY * self.xTileCount;

                        if (typeof self.prevHover == 'number' && self.prevHover >= 0) {
                            self.highlight[self.prevHover].visible = false;
                        }

                        if (
                            hoverX <= self.xTileCount - 1 &&
                            hoverX >= 0 &&
                            hoverY <= self.yTileCount - 1 &&
                            hoverY >= 0
                        ) {
                            self.highlight[hover].visible = true;
                            self.prevHover = hover;
                        }
                    }
                }
                self.puzzleLoader = false;
            }
        },
        randomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        getMask(texture, startPoint, topTab, rightTab, bottomTab, leftTab) {

            let curvyCoords = [
                0, 0, 35, 15, 37, 5,
                37, 5, 40, 0, 38, -5,
                38, -5, 20, -20, 50, -20,
                80, -20, 62, -5, 62, -5,
                60, 0, 63, 5, 63, 5,
                65, 15, 100, 0, 100, 0
            ];

            let mask = new PIXI.Graphics();
            let bgLine = new PIXI.Graphics();
            let bgHighlight = new PIXI.Graphics();
            let borderGrey = new PIXI.Graphics();
            let borderAccent = new PIXI.Graphics();
            bgLine.lineStyle(1, 0x191b1c, 1, 0);
            bgHighlight.lineStyle(1, 0xffffff, 1, 0);
            borderGrey.lineStyle(2, 0x888888, 1, 0);
            borderAccent.lineStyle(2, 0xffffff, 1, 0);
            mask.beginFill(0xFF3300);

            let topLeftEdge = {
                x: startPoint.x,
                y: startPoint.y
            }

            mask.moveTo(startPoint.x, startPoint.y);
            bgLine.moveTo(startPoint.x, startPoint.y);
            bgHighlight.moveTo(startPoint.x, startPoint.y);
            borderGrey.moveTo(startPoint.x, startPoint.y);
            borderAccent.moveTo(startPoint.x, startPoint.y);

            //Top
            for (let i = 0; i < curvyCoords.length / 6; i++) {

                let p1 = {
                    x: topLeftEdge.x + curvyCoords[i * 6 + 0] * this.tileRatio,
                    y: topLeftEdge.y + topTab * curvyCoords[i * 6 + 1] * this.tileRatio
                }

                let p2 = {
                    x: topLeftEdge.x + curvyCoords[i * 6 + 2] * this.tileRatio,
                    y: topLeftEdge.y + topTab * curvyCoords[i * 6 + 3] * this.tileRatio
                }

                let p3 = {
                    x: topLeftEdge.x + curvyCoords[i * 6 + 4] * this.tileRatio,
                    y: topLeftEdge.y + topTab * curvyCoords[i * 6 + 5] * this.tileRatio
                }

                mask.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);

                if (topTab === 0) {
                    bgLine.lineTo(p3.x, p3.y);
                    bgHighlight.lineTo(p3.x, p3.y);
                    borderGrey.lineTo(p3.x, p3.y);
                    borderAccent.lineTo(p3.x, p3.y);
                } else {
                    bgLine.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    bgHighlight.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderGrey.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderAccent.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                }

            }

            //Right

            let topRightEdge = {
                x: topLeftEdge.x + this.tileWidth,
                y: topLeftEdge.y
            }

            for (let i = 0; i < curvyCoords.length / 6; i++) {

                let p1 = {
                    x: topRightEdge.x + -rightTab * curvyCoords[i * 6 + 1] * this.tileRatio,
                    y: topRightEdge.y + curvyCoords[i * 6 + 0] * this.tileRatio
                }

                let p2 = {
                    x: topRightEdge.x + -rightTab * curvyCoords[i * 6 + 3] * this.tileRatio,
                    y: topRightEdge.y + curvyCoords[i * 6 + 2] * this.tileRatio
                }

                let p3 = {
                    x: topRightEdge.x + -rightTab * curvyCoords[i * 6 + 5] * this.tileRatio,
                    y: topRightEdge.y + curvyCoords[i * 6 + 4] * this.tileRatio
                }

                mask.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);

                if (rightTab === 0) {
                    bgLine.lineTo(p3.x, p3.y);
                    bgHighlight.lineTo(p3.x, p3.y);
                    borderGrey.lineTo(p3.x, p3.y);
                    borderAccent.lineTo(p3.x, p3.y);
                } else {
                    bgLine.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    bgHighlight.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderGrey.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderAccent.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                }
            }

            //Bottom

            let bottomRightEdge = {
                x: topRightEdge.x,
                y: topRightEdge.y + this.tileWidth
            }

            for (let i = 0; i < curvyCoords.length / 6; i++) {

                let p1 = {
                    x: bottomRightEdge.x - curvyCoords[i * 6 + 0] * this.tileRatio,
                    y: bottomRightEdge.y - bottomTab * curvyCoords[i * 6 + 1] * this.tileRatio
                }

                let p2 = {
                    x: bottomRightEdge.x - curvyCoords[i * 6 + 2] * this.tileRatio,
                    y: bottomRightEdge.y - bottomTab * curvyCoords[i * 6 + 3] * this.tileRatio
                }

                let p3 = {
                    x: bottomRightEdge.x - curvyCoords[i * 6 + 4] * this.tileRatio,
                    y: bottomRightEdge.y - bottomTab * curvyCoords[i * 6 + 5] * this.tileRatio
                }

                mask.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);

                if (bottomTab === 0) {
                    bgLine.lineTo(p3.x, p3.y);
                    bgHighlight.lineTo(p3.x, p3.y);
                    borderGrey.lineTo(p3.x, p3.y);
                    borderAccent.lineTo(p3.x, p3.y);
                } else {
                    bgLine.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    bgHighlight.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderGrey.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderAccent.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                }
            }

            //Left

            let bottomLeftEdge = {
                x: bottomRightEdge.x - this.tileWidth,
                y: bottomRightEdge.y
            }

            for (let i = 0; i < curvyCoords.length / 6; i++) {

                let p1 = {
                    x: bottomLeftEdge.x - -leftTab * curvyCoords[i * 6 + 1] * this.tileRatio,
                    y: bottomLeftEdge.y - curvyCoords[i * 6 + 0] * this.tileRatio
                }

                let p2 = {
                    x: bottomLeftEdge.x - -leftTab * curvyCoords[i * 6 + 3] * this.tileRatio,
                    y: bottomLeftEdge.y - curvyCoords[i * 6 + 2] * this.tileRatio
                }

                let p3 = {
                    x: bottomLeftEdge.x - -leftTab * curvyCoords[i * 6 + 5] * this.tileRatio,
                    y: bottomLeftEdge.y - curvyCoords[i * 6 + 4] * this.tileRatio
                }

                mask.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);

                if (leftTab === 0) {
                    bgLine.lineTo(p3.x, p3.y);
                    bgHighlight.lineTo(p3.x, p3.y);
                    borderGrey.lineTo(p3.x, p3.y);
                    borderAccent.lineTo(p3.x, p3.y);
                } else {
                    bgLine.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    bgHighlight.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderGrey.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                    borderAccent.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
                }
            }
            mask.endFill();
            return { mask: mask, bgLine: bgLine, bgHighlight: bgHighlight, borderGrey: borderGrey, borderAccent: borderAccent };
        },
        getRandomShapes(width, height) {
            let shapeArray = new Array();

            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {

                    let topTab = undefined;
                    let rightTab = undefined;
                    let bottomTab = undefined;
                    let leftTab = undefined;

                    if (y == 0)
                        topTab = 0;

                    if (y == height - 1)
                        bottomTab = 0;

                    if (x == 0)
                        leftTab = 0;

                    if (x == width - 1)
                        rightTab = 0;

                    shapeArray.push(
                        ({
                            topTab: topTab,
                            rightTab: rightTab,
                            bottomTab: bottomTab,
                            leftTab: leftTab
                        })
                    );
                }
            }

            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {

                    let shape = shapeArray[y * width + x];

                    let shapeRight = (x < width - 1) ?
                        shapeArray[y * width + (x + 1)] :
                        undefined;

                    let shapeBottom = (y < height - 1) ?
                        shapeArray[(y + 1) * width + x] :
                        undefined;

                    shape.rightTab = (x < width - 1) ?
                        this.getRandomTabValue() :
                        shape.rightTab;

                    if (shapeRight)
                        shapeRight.leftTab = - shape.rightTab;

                    shape.bottomTab = (y < height - 1) ?
                        this.getRandomTabValue() :
                        shape.bottomTab;

                    if (shapeBottom)
                        shapeBottom.topTab = - shape.bottomTab;
                }
            }
            return shapeArray;
        },
        getRandomTabValue() {
            return Math.pow(-1, Math.floor(Math.random() * 2));
        },
        close() {
            this.$modal.hide('puzzle');
        }
    }
}
</script>

<style lang="scss">
@import '~@/assets/styles/layout/_puzzle';
</style>
